var currentproduct_id = [...document.querySelectorAll('#product-right [data-backorder-current-product-id]')][0].getAttribute("data-backorder-current-product-id");
var currentproductidnumber = Math.floor(currentproduct_id);
var swatches_shopify_length_varaint = [...document.querySelectorAll('.ib-prod-varient-backorder-flex .product-container-backorder')];
var swatches_custom_length_varaint = [...document.querySelectorAll('.length-swatch-btn')];
var productfetch_url = 'https://api.bombayhair.ca/ca/inventory-quantity/product';
var selection_div_for_padd = [...document.querySelectorAll('.ibat-your-selection')][0];
var addtocart_div = [...document.querySelectorAll('.add-to-cart-wrapper')][0]; 
/* ------------------- Backorder for Shhopify Variant Length and other Swatches ---------- */
var inven_qunty_prod_var_datafetch;
var currentproductbody = {
  productIds: [currentproductidnumber]
};
fetch(productfetch_url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(currentproductbody)
}).then(response => {
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
}).then(data => {
  inven_qunty_prod_var_datafetch = data;
  /*  Check if the variable[array] "swatches_shopify_length_varaint" having any element or not  */
  if(swatches_shopify_length_varaint.length){
    // we did not change currentproductidnumber id
      if(currentproductidnumber != '4889212616778' && currentproductidnumber != '7023857107018' && currentproductidnumber != '7023857172554'){
      swatches_shopify_length_varaint.forEach((elem) => {
        var variant_swatchid_elem_arr = Math.floor(elem.children[0].getAttribute("data-length-swatch-variant-id"));  
        if(inven_qunty_prod_var_datafetch[currentproductidnumber][variant_swatchid_elem_arr] <= 0){
          elem.insertAdjacentHTML('beforeend','<span class="ib-inside-length-backorder"> (Backorder) </span>');
          elem.classList.add('ibat-below-btm');          
        }
      });
      /*  Displaying Backorder for Shopify Variant  */
      var currentactive_shopify_variant = [...document.querySelectorAll('.ib-prod-varient-backorder-flex .product-container-backorder input[checked]')][0].parentElement.querySelectorAll('[data-length-swatch-variant-id]')[0].getAttribute('data-length-swatch-variant-id');
      var inventory_qty_shopifyvar_active = inven_qunty_prod_var_datafetch[currentproductidnumber][currentactive_shopify_variant];
      addbackorder_and_lessthan_stock(inventory_qty_shopifyvar_active);
      /*  Displaying Backorder for Shopify Variant - END  */
    }
  }
  else{
    /*  Doesn't contain any variant  */
    // console.log(currentproductidnumber);
    // we did not change currentproductidnumber id
    if(currentproductidnumber != '4889212616778' && currentproductidnumber != '7023857107018' && currentproductidnumber != '7023857172554'){
      var current_prod_not_having_variant_invenqty = Object.values(inven_qunty_prod_var_datafetch[currentproductidnumber])[0];
      addbackorder_and_lessthan_stock(current_prod_not_having_variant_invenqty);
    }
  }
}).catch(error => {
  console.error('There was a problem with the fetch operation:', error);
});
/* ----------- End -- Backorder for Shopify Length and other Swatches ------------ */

/* ------------------- Backorder for Custom Length Swatches   ---------- */
/*  Check if the variable[array] "swatches_custom_length_varaint" having any element or not  */
if(swatches_custom_length_varaint.length){
  var productid_customlength_array_for_fetch_data = [];
  var allproduct_inven_quantity_for_custom_length_vardata = [];
  swatches_custom_length_varaint.forEach((elem) => {
    productid_customlength_array_for_fetch_data.push(elem.getAttribute("data-product-id"));
  });
  var lengthvaraintproductbody = {
    productIds: productid_customlength_array_for_fetch_data
  };
  fetch(productfetch_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(lengthvaraintproductbody)
  }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  }).then(data => {
    allproduct_inven_quantity_for_custom_length_vardata = data;
    swatches_custom_length_varaint.forEach((elem) => {

  var variant_custom_swatchid_elem_arr = elem.getAttribute("data-product-id");

  if(
    allproduct_inven_quantity_for_custom_length_vardata[variant_custom_swatchid_elem_arr] &&
    Object.values(allproduct_inven_quantity_for_custom_length_vardata[variant_custom_swatchid_elem_arr])[0] <= 0
  ){
    elem.classList.add('is-out-of-stock-length');
  }
  else{
    elem.classList.remove('is-out-of-stock-length');
  }
    });
    /*  For onload Custom varaint  */
    var current_len_var_custom_inven_qty = Object.values(allproduct_inven_quantity_for_custom_length_vardata[currentproductidnumber])[0];
    addbackorder_and_lessthan_stock(current_len_var_custom_inven_qty);
    /*  For onload Custom varaint END */
  }).catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}
/* ----------- End -- Backorder for Custom Length Swatches ------------ */
// if (variant.id == variant_url_id && data.id != '7023857172554' && data.id != '7023857107018' && data.id != '4889212616778') {

var start_url = window.location.href;
var click_for_loc_chng = [...document.querySelectorAll('.ib-prod-varient-backorder-flex .product-container-backorder input')];
click_for_loc_chng.forEach(input_click => {
  input_click.addEventListener("click", function (e) {
    console.log("shopify variant")
    setTimeout(function () {
      // setTimeout(function () {
      //   console.log("Inside the backorder function");
      // const source = document.getElementById("ib-product-price");
      // const source2 = document.getElementById("ib-compare-at-price");
      // const target = document.getElementById("price-under");
      // const target2 = document.getElementById("price-under-compare");
      
      // const timed = setInterval(() => {

      // //   console.log(source.innerHTML.trim())
      // // console.log(target.innerHTML.trim())
      //   if((source.innerHTML.trim() != target.innerHTML.trim()) ){
      //     target.innerHTML = source.innerHTML;
      //     target2.innerHTML = source2.innerHTML;
      //     clearTimeout(timed)
      //   }
      // }, 50);
    
      // }, 500);
      var change_url = window.location.href;
      if (change_url != start_url) {
        var urlString_changed = window.location.search;
          console.log(inven_qunty_prod_var_datafetch);
        if (urlString_changed.startsWith("?variant=")) {
          if(currentproductidnumber != 4889212616778 && currentproductidnumber != 7023857107018 && currentproductidnumber != 7023857172554){
            var variant_url_id = new URLSearchParams(urlString_changed).get("variant");
            var shopify_inventory_qunatity_switchvariant = inven_qunty_prod_var_datafetch[currentproductidnumber][variant_url_id];
            addbackorder_and_lessthan_stock(shopify_inventory_qunatity_switchvariant);
          }
        }
        start_url = change_url;
      }
    }, 800);
  });
});

/* ------ Function START for adding backorder/removing backorder/ adding less than 4 in stock  ------- */
function addbackorder_and_lessthan_stock(inven_qty_no) {
  var backorder_div_variant_change = [...document.querySelectorAll('.ibat-backorder')][0];
  var selection_div_for_padd_change = [...document.querySelectorAll('.ibat-your-selection')][0];
  console.log(inven_qty_no);
  if(inven_qty_no <= 0){
    if(!backorder_div_variant_change){
      addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
      if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
        selection_div_for_padd_change.classList.remove('ibat-without-backorder');
      }
    }
    else if(backorder_div_variant_change.innerText.toLowerCase() != "backorder: ships once in stock"){
      backorder_div_variant_change.remove();
      addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Backorder: Ships Once In Stock</span></div>');
      if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
        selection_div_for_padd_change.classList.remove('ibat-without-backorder');
      }
    }
  } 
  else if(inven_qty_no <= 4 && inven_qty_no >= 1){
    if(!backorder_div_variant_change){
      addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
      if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
        selection_div_for_padd_change.classList.remove('ibat-without-backorder');
      }
    }
    else if(backorder_div_variant_change.innerText.toLowerCase() != "less than 4 in stock"){
      backorder_div_variant_change.remove();
      addtocart_div.insertAdjacentHTML('beforebegin','<div class="ibat-backorder"><span>Less than 4 In Stock</span></div>');
      if(selection_div_for_padd_change && selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
        selection_div_for_padd_change.classList.remove('ibat-without-backorder');
      }
    }
  }
  else {
    if(backorder_div_variant_change){
      backorder_div_variant_change.remove();
      if(!selection_div_for_padd_change.classList.contains('ibat-without-backorder')){
        selection_div_for_padd_change.classList.add('ibat-without-backorder');
      }
    }
  }
}
/* ------ Function END for adding backorder/removing backorder/ adding less than 4 in stock  ------- */